<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('user_group') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/group" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-header">
                    <div class="card-item upper">{{ $t('user_group') }}</div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered no-bor">
                        <thead colspan="2">
                            <tr>
                                <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                <th>{{ $t('group_name') }}</th>
                                <th>{{$t('sort')}}</th>
                                <th style="width: 140px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name:'user_group_update', params: { id: ret.Id }}">{{ret.Name}}</router-link></td>
                                <td>{{ret.Sort}}</td>
                                <td class="text-center"><router-link :to="{name:'permission_update', params: { id: ret.Id }}" class="btn btn-success btn-table-xs btn-block">{{$t('set_permission')}}</router-link></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    Text: ''
                },
                records:[],
                view_type: 0
            }
        },
        created() {
            this.toList();
        },
        methods: {
            toList(){
                let self = this;
                let loading = this.$loading.show();
                this.$api().post('user/groups', this.query).then((res) => {
                    if(this.$isValid(res)){
                        self.records = res.data.Json.Groups;
                    }
                }).finally(function(){ loading.hide(); });
            }
        }
    }
</script>